module.exports = __webpack_public_path__ + "fonts/certificate.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/certificate.svg
// module id = 1686
// module chunks = 0